<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >   
        <CForm id="customers_form" method="POST" enctype="multipart/form-data" v-if="!submitted">
            <CRow>
              <CCol md="12">
                <a style="float: right; font-size: 12px;" target="_blank" href="https://api.kpibonus.com/customers.xlsx">Descargar Plantilla</a>
                <CInput
                  label="Archivo a Importar:"
                  name="file"
                  id="file"
                  type="file"
                  :lazy="false"
                  :value.sync="$v.form.file.$model"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                  required
                />
              </CCol>
            </CRow>
        </CForm>

        <template v-else>
          <CRow>
            <CCol md="12">
              <div class="processing-box" v-if="isProcessing">
                <div class="spinner-circle"></div>
                <div>
                  <strong>La importación de clientes sigue en proceso.</strong>
                  <div class="processing-subtitle">Por favor espera. No cierres esta ventana.</div>
                </div>
              </div>

              <CAlert v-else-if="hasErrorsImport == 1" color="danger" variant="solid">
                <strong>La importación finalizó con errores.</strong>
              </CAlert>

              <CAlert v-else-if="hasFinished" color="success" variant="solid">
                <strong>La importación se completó correctamente.</strong>
              </CAlert>

              <div v-if="importSummary" class="summary-text">{{ importSummary }}</div>

              <CDataTable
                v-if="hasErrorsImport == 1"
                :items="importIssues"
                :fields="['N°', 'Fila', 'Columna', 'Error']"
                :items-per-page="10"
                hover
                bordered
                small
                responsive
                class="mt-3"
                :no-sorting="true"
                :sorter="false"
              >
                <template #N°="{ index }">
                  <td style="font-size: 10px;">{{ index + 1 }}</td>
                </template>
                <template #Fila="{ item }">
                  <td style="font-size: 10px;">{{ item.row || '-' }}</td>
                </template>
                <template #Columna="{ item }">
                  <td style="font-size: 10px;">{{ item.column || '-' }}</td>
                </template>
                <template #Error="{ item }">
                  <td style="font-size: 10px;">{{ item.message }}</td>
                </template>
              </CDataTable>
            </CCol>
          </CRow>
        </template>

        <template #footer>
          <template v-if="submitted && !isProcessing">
            <CButton @click="closeModal" color="secondary">Cerrar</CButton>
          </template>
          <template v-else-if="isProcessing">
            <CButton color="secondary" disabled>Procesando...</CButton>
          </template>
          <template v-else>
            <CButton @click="closeModal" color="secondary">Cancelar</CButton>
            <CButton @click="importCustomers" :color="color">Importar</CButton>
          </template>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import ws from '../../services/customers';
import store from '../../store'

export default {
  name: 'ImportCustomersModal',
  props: {

  },
  data () {
    return {
      showModal: false,
      title: "Importar Clientes",
      color: "success",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      hasErrorsImport: 0,
      importIssues: [],
      importSummary: "",
      importId: 0,
      isProcessing: false,
      hasFinished: false,
      pollingId: null,
      pollingIntervalMs: 2500,
    }
  },
  methods: {
    importModal () {
      this.showModal = true;
      this.color = "success";
      this.title = 'Importar Clientes';
      this.isEdit = false;
      this.resetImportState();
    },
    async importCustomers () {
      this.loading();
      this.$v.$touch();

      if (!this.isValid) {
        this.showToast("error", "Debes ingresar un archivo XLSX para poder continuar.");
        this.loaded();
        return;
      }

      this.submitted = true;

      try {
        const form = document.getElementById("customers_form");
        const formData = new FormData(form);

        const response = await ws.import(formData);

        if(response.type == "success"){
          this.importId = response.data.import_id || 0;
          this.isProcessing = true;
          this.hasFinished = false;

          this.showToast("info", response.message);
          this.startImportPolling();
          return;
        }

        this.showToast(response.type, response.message);
        this.submitted = false;
      } catch (error) {
        this.showToast("error", "No se pudo iniciar la importación de clientes.");
        this.submitted = false;
      } finally {
        this.loaded();
      }
    },
    async fetchImportStatus () {
      if(!this.importId){
        return;
      }

      try {
        const response = await ws.importStatus(this.importId);

        if(response.type != "success"){
          this.stopImportPolling();
          this.isProcessing = false;
          this.showToast(response.type, response.message);
          return;
        }

        const payload = response.data || {};

        this.hasErrorsImport = payload.has_errors ? 1 : 0;
        this.importIssues = payload.issues || [];
        this.importSummary = payload.summary || "";

        if(payload.is_finished){
          this.stopImportPolling();
          this.isProcessing = false;
          this.hasFinished = true;
        }
      } catch (error) {
        this.stopImportPolling();
        this.isProcessing = false;
        this.showToast("error", "No se pudo consultar el estado de la importación.");
      }
    },
    startImportPolling () {
      this.stopImportPolling();
      this.fetchImportStatus();
      this.pollingId = setInterval(() => {
        this.fetchImportStatus();
      }, this.pollingIntervalMs);
    },
    stopImportPolling () {
      if(this.pollingId){
        clearInterval(this.pollingId);
        this.pollingId = null;
      }
    },
    closeModal () {
      if(this.isProcessing){
        this.showModal = true;
        this.showToast("info", "La importación sigue en proceso. Espera a que termine para cerrar.");
        return;
      }

      this.showModal = false;

      if(this.hasFinished){
        this.$emit("import");
      }

      this.resetImportState();
    },
    resetImportState () {
      this.stopImportPolling();
      this.form = this.getEmptyForm();
      this.submitted = false;
      this.hasErrorsImport = 0;
      this.importIssues = [];
      this.importSummary = "";
      this.importId = 0;
      this.isProcessing = false;
      this.hasFinished = false;
      this.$v.$reset();
    },
    getEmptyForm () {
      return {
          id: 0,
          file: '',
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  watch: {
    showModal (value) {
      if (!value && this.isProcessing) {
        this.showModal = true;
        this.showToast("info", "La importación sigue en proceso. Espera a que termine para cerrar.");
      }
    }
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      file: {
        required
      }
    }
  },
  beforeDestroy () {
    this.stopImportPolling();
  }
}
</script>

<style scoped>
.processing-box {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #eef3ff;
}

.spinner-circle {
  width: 18px;
  height: 18px;
  border: 2px solid #c9d6ff;
  border-top-color: #4a6ff3;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

.processing-subtitle {
  font-size: 12px;
  color: #5b6470;
}

.summary-text {
  font-size: 12px;
  margin-top: 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>